module.exports = __webpack_public_path__ + "static/media/expert6.f0eea4bd.png";